import React, { useEffect, useState } from "react";
import "./productCard.scss";
import { Link } from "react-router-dom";
import { Box, CircularProgress } from "@mui/material";
import categoryStore from "../../store/categoryStore";
import authStore from "../../store/authStore";
import { PRODUCT_IMAGE_URL } from "../../constant";
import wishlistStore from "../../store/wishlistStore";

// Icons
import FavoriteRoundedIcon from "@mui/icons-material/FavoriteRounded";

const ProductCard = ({ item, width, height, myGender }) => {
  const CategoryStore = categoryStore();
  const AuthStore = authStore();
  const WishlistStore = wishlistStore();

  const [categoryName, setCategoryName] = useState();
  const [to, setTo] = useState("");
  const [isWishlist, setIsWishlist] = useState(false);
  const [isWishlistLoading, setIsWishlistLoading] = useState(false);
  const [wishlistID, setWishlistID] = useState();

  useEffect(() => {
    if (CategoryStore.category) {
      CategoryStore.category.filter((category) => {
        return (
          category._id === item.categoryID &&
          setCategoryName(category.categoryName)
        );
      });
    }
  }, []);

  useEffect(() => {
    if (WishlistStore.wishlistProduct) {
      for (let i = 0; i < WishlistStore.wishlistProduct.length; i++) {
        if (item._id === WishlistStore.wishlistProduct[i].productID) {
          setIsWishlist(true);
          setWishlistID(WishlistStore.wishlistProduct[i]._id);
        }
      }
    }
  }, [WishlistStore.wishlistProduct && WishlistStore.wishlistProduct.length]);

  useEffect(() => {
    if (myGender) {
      setTo(
        `/${myGender}/${categoryName}/${item.productName}/${item._id}/details`
      );
    } else {
      setTo(`/${categoryName}/${item.productName}/${item._id}/details`);
    }
  }, [categoryName]);

  return (
    <Box className="single-product" width={width}>
      <Box component="div" className="product-image">
        <Link style={{ height: height }} className="link" to={to}>
          <Box
            className="home-product-image"
            component="img"
            alt={`${PRODUCT_IMAGE_URL}${item.productImages[1]}`}
            src={`${PRODUCT_IMAGE_URL}${item.productImages[1]}`}
          />
          <Box
            component="img"
            alt={`${PRODUCT_IMAGE_URL}${item.productImages[0]}`}
            src={`${PRODUCT_IMAGE_URL}${item.productImages[0]}`}
          />
        </Link>
        {AuthStore.isLogged && (
          <div
            className="card-wishlist-container"
            onClick={async () => {
              setIsWishlistLoading(true);
              if (isWishlist) {
                await WishlistStore.removeToWishlist({
                  wishlistID,
                  productID: item._id,
                  productName: item.productName,
                  productPrice: item.salePrice
                    ? item.salePrice
                    : item.regularPrice,
                });
              } else {
                await WishlistStore.addToWishlist({
                  productID: item._id,
                  productName: item.productName,
                  productPrice: item.salePrice
                    ? item.salePrice
                    : item.regularPrice,
                });
              }
              setIsWishlistLoading(false);
              setIsWishlist(!isWishlist);
            }}
          >
            <p>Quick Look</p>
            {isWishlistLoading ? (
              <CircularProgress className="progress" size="18px" />
            ) : (
              <FavoriteRoundedIcon
                className={`icon ${isWishlist && "is-wishlist"}`}
              />
            )}
          </div>
        )}
      </Box>

      <div className="product-basic-details">
        <Link
          className="link"
          to={to}
          onClick={() => {
            window.scrollTo({ top: 0, behavior: "smooth" });
          }}
        >
          <p className="product-title">{item.productName}</p>
          <div className="product-price">
            <p className={`regular-price ${item.salePrice && "is-sale"}`}>
              ₹{item.regularPrice}
            </p>
            {item.salePrice && <p className="sale-price">₹{item.salePrice}</p>}
          </div>
        </Link>
      </div>
    </Box>
  );
};

export default ProductCard;
